import {Button, Divider, Modal, Spin} from "antd";
import React, {useEffect, useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiReadStudentProfile, useApiUpdateAdminProfile} from "@/api/userAcademy";
import {useApiLocationCountry} from "@/api/location";
import UploadCMP from "@/components/upload";
import FilePreview from "@/components/file-preview/file-preview";
import {useParams} from "react-router-dom";

export default function ChangeDocumentModal({onSubmit, onClose, openModal}) {
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState()

    const {data: country} = useApiLocationCountry()
    const params = useParams()

    const {mutate: updateProfile} = useApiUpdateAdminProfile();
    const {data: user, isPending: isPending, isSuccess, refetch, isRefetching} = useApiReadStudentProfile()

    useEffect(() => {
        if (user) {
            {
                setUserData(user)
            }
        }
    }, [user])


    function updateProfileDoc(key, file) {
        let update = {}
        update[key] = file;
        update['id'] = params.id;

        setLoading(true);
        updateProfile(update, {
            onSuccess: (res) => {
                refetch()
                ApiHandleSuccessMessage(res);
                setLoading(false);
            },
            onError: (errors) => {
                ApiHandleErrorMessage(errors);
                setLoading(false);
            },
        });
    }

    let loadingElement = (
        <div>لطفا تصاویر مدارک هویتی خود را بارگذاری کنید{loading ? <Spin spinning={loading}></Spin> : null}</div>)

    return (
        <Modal
            title={loadingElement}
            open={openModal}
            onCancel={() => {
                onClose?.();
            }}
            footer={[
                <Button onClick={() => onClose?.()}>لغو</Button>,

            ]}
        >
            <div className="flex flex-col gap-3">
                <div className={'flex gap-3 justify-between items-center'}>
                    <UploadCMP label={'تصویر کارت شناسایی'} afterUploadFn={(a) => {
                        updateProfileDoc('file1', a?.file?.response?.data?.id)
                    }}>
                    </UploadCMP>
                    <FilePreview fileUrl={userData?.data?.data?.file1}/>
                </div>
                <Divider type={'horizontal'}/>

                <div className={'flex gap-3 justify-between items-center'}>
                    <UploadCMP label={'تصویر کارت ملی'} afterUploadFn={(a) => {
                        updateProfileDoc('file2', a?.file?.response?.data?.id)
                    }}>
                    </UploadCMP>
                    <FilePreview fileUrl={userData?.data?.data?.file2}/>
                </div>
                <Divider type={'horizontal'}/>


                <div className={'flex gap-3 justify-between items-center'}>
                    <UploadCMP label={'تصویر مدرک تحصیلی'} afterUploadFn={(a) => {
                        updateProfileDoc('file3', a?.file?.response?.data?.id)
                    }}>
                    </UploadCMP>
                    <FilePreview fileUrl={userData?.data?.data?.file3}/>
                </div>
                <Divider type={'horizontal'}/>

            </div>
        </Modal>
    );
}
